import getPricingFromField from './getPricingFromField';

const fieldTotalKeys = [
  'monthly',
  'oneTime',
  'threeYearEasyPayment',
  'fiveYearEasyPayment'
];

const getTotalsForSetOfTotals = (
  fieldsNames,
  formFields,
  orderData,
  customPriceCalculators
) => {
  return fieldsNames.reduce(
    (acc, field) => {
      let fieldPrice;
      if (customPriceCalculators && customPriceCalculators[field]) {
        fieldPrice = customPriceCalculators[field](
          field,
          formFields,
          orderData
        );
      } else {
        fieldPrice = getPricingFromField(
          formFields[field],
          orderData[field] || {}
        );
      }
      fieldTotalKeys.forEach(key => {
        acc[key] += fieldPrice[key];
      });
      return acc;
    },
    {
      monthly: 0,
      oneTime: 0,
      threeYearEasyPayment: 0,
      fiveYearEasyPayment: 0
    }
  );
};

export default getTotalsForSetOfTotals;
